import React, { Component, PropTypes } from 'react';
import { withRouter } from 'react-router';

import HeaderMenuSearch from '../../components/HeaderMenu/components/HeaderMenuSearch';
import { searches } from '../../utils/localStorage';
import { setLocalStorage, stringifyQS } from '../../utils';

class HeaderSearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: props.searchVisible,
      expanded: false,
      expandedField: undefined,
      values: {},
      showAll: true,
    };
  }

  onEsc = (event) => {
    const { search } = this.state;
    const keyCode = event.keyCode;
    if (keyCode === 27 && search) {
      this.setState({ search: !search });
    }
  }

  onChange = (values) => {
    this.setState({ values });
  }

  onSubmit = () => {
    this.setState({
      search: !this.state.search,
    }, this.props.onSearchCloseClick);

    const values = this.cleanValues(this.state.values);
    const queryString = stringifyQS(values);
    // Save search to local storage
    setLocalStorage(searches.last.key, JSON.stringify(values));
    this.props.router.push(`/s?${queryString}`); // eslint-disable-line react/prop-types
  }

  toggleSearch = () => {
    this.setState({
      search: !this.state.search,
    }, this.props.onSearchCloseClick);
  }

  cleanValues = values =>
    // The values object represents the current state of selections,
    // not the computed values to be submitted, this function determines those choices
    Object.keys(values)
      // Fields to remove, e.g. slugs (using ID instead), non-search params e.g. geolocation
      .filter(key => ![
        'locationSlug',
        'geolocation',
        'locationName',
        'locationLat',
        'locationLong',
        'viewportNorthEastLat',
        'viewportNorthEastLong',
        'viewportSouthWestLat',
        'viewportSouthWestLong'].includes(key))
      .reduce((obj, key) => {
        // Location is a complex object, we only need the lat and long params
        if (key === 'location' && values[key]) {
          const place = values[key];
          // These location types have bounds search
          if (['country', 'administrative_area_level_1', 'administrative_area_level_2', 'bounds'].includes(place.types[0])) {
            return {
              ...obj,
              locationName: place.name,
              viewportNorthEastLat: place.geometry.viewport.getNorthEast().lat(),
              viewportNorthEastLong: place.geometry.viewport.getNorthEast().lng(),
              viewportSouthWestLat: place.geometry.viewport.getSouthWest().lat(),
              viewportSouthWestLong: place.geometry.viewport.getSouthWest().lng(),
            };
          }
          // Otherwise use a single-point search
          return {
            ...obj,
            locationName: place.name,
            locationLat: place.geometry.location.lat(),
            locationLong: place.geometry.location.lng(),
          };
        }
        // Radius is only valid for single-point queries
        if (key === 'locationSearchRadius'
            && (['country', 'administrative_area_level_1', 'administrative_area_level_2'].includes(values.location && values.location.types[0]) || !values.location)) {
          return {
            ...obj,
            [key]: undefined,
          };
        }
        // Everything else is fine, but nullify empty strings for brevity
        return {
          ...obj,
          [key]: values[key] === '' ? null : values[key],
        };
      }, {});

  toggleField = (event) => {
    const { id, name } = event.target;
    if (this.state.expandedField !== (id || name)) {
      this.setState({
        expanded: true,
        expandedField: id || name,
      });
    }
  }

  showAllFields = () => {
    this.setState({
      expanded: false,
      expandedField: undefined,
    });
  }

  render() {
    const { expanded, expandedField } = this.state;
    const { onSearchCloseClick, className } = this.props;

    // If a field is expanded, then do not render other field.
    let hideName;
    let hideType;
    if (expanded && expandedField === 'name') {
      hideType = true;
      hideName = false;
    // Else if a field is expanded that field is not 'name'
    // i.e. filters, then only render those filters.
    } else if (expanded && expandedField !== 'name') {
      hideName = true;
      hideType = false;
    }

    return (
      <div className={className}>
        <HeaderMenuSearch
          showAllFields={this.showAllFields}
          searchByName={expandedField === 'name'}
          searchByType={expandedField === 'searchByType'}
          hideName={hideName}
          hideType={hideType}
          toggleField={this.toggleField}
          onSearchCloseClick={onSearchCloseClick}
          toggleSearch={this.toggleSearch}
          onChange={this.onChange}
          onSubmit={this.onSubmit}
          onEsc={this.onEsc}
          {...this.props}
          {...this.state}
        />
      </div>
    );
  }
}

HeaderSearch.propTypes = {
  /*
   * String class names to append to component styles.
   */
  className: PropTypes.string,
  /*
   * Function to trigger closing of search.
   */
  onSearchCloseClick: PropTypes.func,
  /*
   * Bool to determine whether search is currently visible or not.
   */
  searchVisible: PropTypes.bool,
};

HeaderSearch.defaultProps = {
  className: '',
  onSearchCloseClick: () => {},
  searchVisible: false,
};

const HeaderSearchWithRouter = withRouter(HeaderSearch);

export default HeaderSearchWithRouter;



// WEBPACK FOOTER //
// ./app/src/containers/HeaderSearch/index.jsx